import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environment';

export const apimInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    environment.useApim === true
      ? req.clone({
          headers: req.headers.set('Ocp-Apim-Subscription-Key', environment.secret),
        })
      : req,
  );
};
